import  { useState,forwardRef,useImperativeHandle } from "react";

const ValidationPopup = forwardRef((props,ref) => {

    let setIsLoading= props.setIsLoading;
    const [isSavedSuccessfully, setIsSavedSuccessfully] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    useImperativeHandle(ref, () => ({

        getResponse(statusCode,records) {
            if(statusCode !== null && statusCode !== undefined && statusCode !== "")
                if(statusCode === 200)
                    setIsSavedSuccessfully(true);
                else{
                    setIsSavedSuccessfully(false);

                    if(statusCode === 400)
                        setErrorMessage("Invalid request exception");
                    else if(statusCode === 503)
                        setErrorMessage("Service unavailable");
                    else
                        setErrorMessage("");
                }
                setIsLoading(false);
            }
      }));

    const closeSuccessPopup=()=>{
        setIsSavedSuccessfully(null);
    }

    const finalSaved = () =>{
        window.location.reload();
    }

    return (
        <div>
        {isSavedSuccessfully !== null && isSavedSuccessfully !== "" && isSavedSuccessfully ?
            <div  className="tds-successful-bg" >
                <div className="tds-successful-message">
                    <div className="alert alert-success">
                        <strong>Success! </strong> Thank you for registering with us
                    </div>
                    <button onClick={finalSaved} className="success-btn btn-blue">Ok</button>
                </div>
            </div>
            : isSavedSuccessfully !== null && isSavedSuccessfully !== "" && !isSavedSuccessfully ?
            <div  className="tds-successful-bg" >
                <div className="tds-successful-message">
                    <div className="alert alert-danger">
                        <strong>Failure! </strong> Record not saved successfully {errorMessage !== ""? "( "+ errorMessage+" )":""}
                    </div>
                    <button onClick={closeSuccessPopup} className="success-btn btn-blue">Close</button>
                </div>
            </div>
            : ""
        }
        </div>
    )
});

export default ValidationPopup